import { Box, styled } from '@mui/material';

export const FormWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.themeColors.activeForm.border}`,
  padding: theme.spacing(3),
  textAlign: 'initial',
  overflow: 'scroll',
  height: '100%',
}));
